<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Plano Manutenção</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            color="info"
            to="/planoManutencao/criar"
            v-if="isAllowed(14)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="planosManutencao.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="planosManutencao.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(14)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroPlanoManutencao";
import { getUserRoles } from "@/services/loginService";
import { saveAs } from "file-saver";

export default {
  name: "listaPlanosManutencao",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      active_tab: 1,
      headers: [
        {
          text: "Id", align: "start", value: "id",
        },
        { text: "Descrição", value: "descricao" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        descricao: [],
      },
    };
  },
  computed: {
    ...mapState("planoManutencao", ["planosManutencao"]),
    ...mapGetters("produto", { listaProdutos: "produtosSomente" }),
    filteredList() {
      if (this.showAtivo === false) {
        var newList = this.planosManutencao.filter((pm) => {
          return (
            pm.descricao.toLowerCase().includes(this.search.toLowerCase()) &&
            pm.ativo === true
          );
        });
        return newList.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        var novaLista = this.planosManutencao.filter((pm) => {
          return pm.descricao.toLowerCase().includes(this.search.toLowerCase());
        });
        return novaLista.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("planoManutencao", ["atualizarPlanosManutencao", "atualizarPlanoManutencao"]),
    ...mapActions("produto", ["atualizarListaProdutos"]),
    ...mapActions("compartimento", ["atualizarCompartimentos"]),
    editar(planoManutencao) {
      this.atualizarPlanoManutencao(planoManutencao);
      if (this.isAllowed(14)) {
        this.$router.push(`/planoManutencao/editar`);
      } else {
        this.$router.push(`/planoManutencao/ver`);
      }
    },
    baixarlista() {
      const blob = this.gerarExcel();
      const nome_arquivo = "planosManutencao.xlsx";
      saveAs(blob, nome_arquivo);
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarPlanosManutencao();
      await this.atualizarCompartimentos();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
    doAjax() {
      if (!this.listaProdutos || this.listaProdutos.length == 0) {
        this.atualizarListaProdutos();
      }
    },
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Id" },
        { chave: "descricao", cabecalho: "Descricao" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "data") {
              return new Date(item[c.chave])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
            } else if (c.chave === "id") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  created: function () {
    this.obterLista();
    this.doAjax();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacao,
  },
};
</script>
